<template>
    <div>
        <breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'市场行情信息反馈'}]" />
        <div class="h-content" >
            <!-- 搜素条件 -->
            <div class="h-piece" >
                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                  <div class="h-thirdColumn w-newColumn">
                    <el-form-item label="经销商编码">
                      <el-input v-model="q.agentCode" :clearable="true"></el-input>
                    </el-form-item>
                    <el-form-item label="经销商名称">
                      <el-input v-model="q.agentName" :clearable="true"></el-input>
                    </el-form-item>
<!--                      <el-form-item label="区域" prop="area">-->
<!--                        <el-select v-model="q.areaCode" clearable placeholder="请选择" style="width:100%">-->
<!--                          <el-option v-for="item in quyuList"-->
<!--                                     :key="item.code"-->
<!--                                     :label="item.name"-->
<!--                                     :value="item.code">-->
<!--                          </el-option>-->
<!--                        </el-select>-->
<!--                      </el-form-item>-->
                    <el-form-item label="年度">
                      <el-select filterable v-model="q.weekYear" clearable placeholder="请选择"
                                 @change="getqWeeksBySelectYear">
                        <el-option
                            v-for="(item,index) in yearList"
                            :key="item"
                            :label="item"
                            :value="item">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item  label="周" class="h-elformWrap-2" prop="username">
                      <el-select filterable v-model="q.weekTime" clearable  placeholder="请选择"
                      >
                        <el-option
                            v-for="(item,index) in qweekList"
                            :key="item.week"
                            :label="item.weekStr"
                            :value="item.week">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-form>
                <!-- 展开搜素 -->
                <div class="l-screenBox">
                    <div class="l-retrieval">
                    <el-button class="h-btn h-formBtn" @click="selectPageAll">检索</el-button>
                    <el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>
                    </div>
                </div>
            </div>
            <!-- 结果展示 -->
            <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
                <!--  -->
                <el-table
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    :data="tableData"
                    :border="true"
                    stripe
                    max-height="560"
                    style="width: 100%" >
                    <el-table-column
                        type="selection"
                        width="55">
                    </el-table-column>
                        <el-table-column
                            label="序号"
                            type="index"
                            width="50">
                        </el-table-column>
                    <el-table-column prop="areaCode" label="区域" min-width="10%">
                      <template slot-scope="scope">
                        {{scope.row.areaCode | dictname('YLRegion')}}
                      </template>
                    </el-table-column>
                    <el-table-column prop="agentName" label="经销商名称" min-width="13%"></el-table-column>
                  <el-table-column prop="agentCode" label="经销商编码" min-width="10%"></el-table-column>
                    <el-table-column prop="cdate" label="反馈日期" :formatter="formatDate" min-width="10%" ></el-table-column>
                    <el-table-column prop="competitorAnalysis" label="市场信息描述" min-width="24%" :show-overflow-tooltip="true"></el-table-column>
                </el-table>
                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                        <div class="h-tableBL">
<!--                             <el-button :disabled="this.multipleSelection.length === 0" class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-delete" @click="deleteSelete">批量删除</el-button>-->
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
<!--                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"-->
<!--                                @click="uploaddownexcelflagbtn">批量导入-->
<!--                            </el-button>-->
                            <uploaddownexcel
                                    :visible.sync="uploaddownexcelflag"
                                    v-if="uploaddownexcelflag"
                                    clsname="marketConditionsDownloadExcel"
                                    :startrow="2" @callback="uploadExcelFilecallback"/>
                        </div>
                    </div>
                    <div class="h-pagination2">
                        <pagination :page="q" @query="selectPageAll" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ss from "../../../api/SystemService";
import updownfile from '../../../utils/updownfile'
import util from "../../../utils/util";
import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
import weekYearMonthService from "../../../api/loud/weekMeeting/weekYearMonthService";
import moment from "moment";
export default {
    data() {
        return {
            q:{
                agentName:'',
                agentCode:'',
                weekYear:'',
                weekTime:'',
                pageNo:1,
                pageSize:10,
                total:0,
            },
            qyearList: [],
            quyuList: [],
            qudaoList:[],
            size:'',
            tableData: [],
            //表格
            multipleSelection: [],
            // 展开折叠筛选
            isScreen:false,
            uploaddownexcelflag:false,
            newDialog:false,
            editDialog:false,
            yearList:[new Date().getFullYear(),new Date() .getFullYear()+1],
            qweekList :[],
            add:{
                year:'',
                week:'',
                userList:[0],
                targetContent:'',
                customerName:'',
                visitDateNew:'',
                clearType:''
            },
            UserMarketConditions:{
              areaName:'',//区域名称
              areaCode:'',//区域编码
              agentCode:'',//经销商编码
              agentName:'',//经销商名称
              feedbackDate:'',//反馈日期
              describe:'',//市场信息描述
            },
        }
        
    },
   
    methods: {
         
        //表格
        handleSelectionChange(val) {
           this.multipleSelection = val;
        },
        deleteSelete(){
            // var data = this.multipleSelection.map(item => item.id).join()
            var idlist = [];
            this.multipleSelection.forEach(element => {
              idlist.push(element.id);
            });
            console.log(idlist)
            this.deleteSingle(idlist)
        },
        deleteSingle(id){
            console.log("id",id)
            var data = id
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    ss.grabOrderApi.deleteUserMarketConditions(data).then(res => {
                        console.log(res)
                        if(res.f == true ){
                             this.$message({
                                  type: 'success',
                                  message: '删除成功!'
                            });
                            this.selectPageAll()
                        }else{
                            this.$message.error(res.msg);
                        }
                    })
                   
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });

        },
        selectPageAll(){
            ss.grabOrderApi.selectPageUserMarketConditions(this.q).then(res => {

                console.log(res)
                this.tableData = res.records;
                this.q.total = res.total;
            })
        },
        //
        uploaddownexcelflagbtn() {
            this.uploaddownexcelflag = true;
        },
        uploadExcelFilecallback(rd) {
            this.$msg.msgs(rd.msg);
            this.selectPageAll()
        },
        //导出
		exportExcel() {
            updownfile.down("/api/swyl/v1/demo/userMarketConditions/marketConditionsDownloadExcel",this.q,"post",);
        },
        getNowTime() {
            var now = new Date();
            var year = now.getFullYear(); //得到年份
            var month = now.getMonth(); //得到月份
            var date = now.getDate(); //得到日期
            month = month + 1;
            month = month.toString().padStart(2, "0");
            date = date.toString().padStart(2, "0");
            var defaultDate = `${year}-${month}-${date}`;
        },

        //新增日清
        create(){
            this.newDialog = true;
            this.titleDig="新建日计划"
        },
        // 展开折叠
        collapseChange(){
            this.isScreen = !this.isScreen;
        },
        rest(){
            var pageSize=this.q.pageSize;
            var pageNo=this.q.pageNo;
            var total=this.q.total;
            this.q= {
                pageSize: pageSize,
                pageNo: pageNo,
                total:total,
                agentName:'',
                customerName:'',
                areaCode:'',
                chanelCode:''
            }
        },
        exit(){
            this.newDialog= false,
            this.editDialog = false
        },
        getQuyuList(){
          ss.Dictservice.listbycategory("YLRegion").then(rd=>{
            this.quyuList = rd;
          })
        },
        getQudaoList(){
          ss.Dictservice.listbycategory("sales_region").then(rd=>{
            this.qudaoList = rd;
          })
        },
      getWeeks(y){
        ss.MuBiao.getWeekList({year:y}).then(rd => {
          this.weekList = rd;
        })
      },
      getqWeeksBySelectYear(){
        this.getqWeeks(this.q.year);
      },
      getqWeeks(y){
        weekYearMonthService.getWeekList({year:y}).then(rd => {
          this.qweekList = rd;
          this.getKnowWeek();
        })
      },
      //获取今年是第几周
      getWeekNum() {
        //获得当前日期是第几周的方法
        var year = new Date().getFullYear();
        var week = moment(new Date()).format("E");//获得今天是星期几
        console.log("week",week)
        var startweek = moment(new Date(year + "-01-01")).format("E");//获得今年的1月1号是星期几
        //今天到1月1号的时间戳之差
        var millisDiff =
            new Date(moment().format("yyyy-MM-DD")).getTime() -
            new Date(year + "-01-01").getTime();
        var days =
            (millisDiff -
                week * (24 * 60 * 60 * 1000) -
                (7 - startweek) * (24 * 60 * 60 * 1000)) /
            86400000;
        return days / 7 + 1;
        //这里加的2代表的是本周和今年1月1号所在的那一周
      },
      getKnowWeek() {
        var week1 = this.getWeekNum();
        this.qweekList.forEach(element => {
          if(week1 == element.week){
            this.q.weekTime = element.week
          }
        });
      },
      formatDate(row, column) {
        // 获取单元格数据
        let data = row[column.property]
        if(data == null || data == '') {
          return null
        }
        let dt = new Date(data)
        return this.$util.riQi3(dt);
      },
    },
    watch:{
        'add.customerName': {
            deep: true,
            handler: function (newVal,oldVal){
            this.groupArr = [];//这是定义好的用于存放下拉提醒框中数据的数组
            var len = this.groupList.length;//groupList
            var arr = [];
            for (var i = 0; i < len; i++) {//根据输入框中的值进行模糊匹配
                if (this.groupList[i].name.indexOf(this.add.customerName) >= 0) {
                arr.push({
                    value:this.groupList[i].name,
                    id:this.groupList[i].id
                })
                }
            }
            this.groupArr = arr
            }
        },
    },
    created(){
        this.selectPageAll()
        this.add.year =  this.yearList[0]
        this.getWeeks(new Date().getFullYear());
        this.getQuyuList();
        this.getQudaoList();
        for(var i =2021;i<new Date() .getFullYear()+2;i++){
          this.qyearList.push(i);
        }
    },
    components: {
        uploaddownexcel,
    },
}
</script>
<style scoped>
    /deep/ .h-formbLine .el-form-item__label{
        width:80px;
    }
    /deep/  .h-formbLine .el-form-item__content{
        width:150px;
    }
</style>